/**
 * WebSocket event names for candidate notifications (bell + toast).
 * Recruiter-only events (e.g. chatRequestAccepted) are not listed here.
 */
export const REALTIME_NOTIFICATION_EVENTS = [
  'newQuestion',
  'questionAnswered',
  'question_updated',
  'chatRequest',
  'referenceConfirmed',
  'newMessage',
  'profileAccessRequest',
  'meeting_request_created',
  'meeting_request_updated',
  'meeting_request_rescheduled',
  'profileLike',
  'notification',
] as const;

/** Refresh analytics + /prompts stats without showing a toast. */
export const REALTIME_ANALYTICS_REFRESH_EVENTS = ['candidateAnalyticsUpdated'] as const;

export type RealtimeNotificationEvent = (typeof REALTIME_NOTIFICATION_EVENTS)[number];

export type RealtimeAnalyticsRefreshEvent = (typeof REALTIME_ANALYTICS_REFRESH_EVENTS)[number];

export const SKIPSCREEN_ANALYTICS_UPDATED_EVENT = 'skipscreen:analytics-updated';

/** Refetch dashboard widgets (activity feed, trends, metrics). */
export const SKIPSCREEN_DASHBOARD_REFRESH_EVENT = 'skipscreen:dashboard-refresh';

/** Refetch calendar meeting requests, slots, and busy times. */
export const SKIPSCREEN_CALENDAR_REFRESH_EVENT = 'skipscreen:calendar-refresh';
